<template>
  <div class="admin" :class="{ collapse: adminCollapse }">
    <img src="@/assets/images/avatar.png" alt="" />
    <span>{{ $store.state.adminUser.userName }}</span>
  </div>
</template>

<script>
export default {
  props: {
    adminCollapse: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./admin.scss");
</style>